
export function toPdfPoint(millimeters: number) {
	return (millimeters / 25.4 * 72);
}
export function toMillimeters(pdfPoint: number) {
	return (pdfPoint / 72 * 25.4);
}
